const teaching = [
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/Dr.P.%20Gopal.jpg",
    name: "Dr. P. Gopal",
    designation: "Head & Assistant Professor (Sl.Gr.)",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/picture-navin.jpg",
    name: "Dr.P. Navaneetha Krishnan",
    designation: "Assistant Professor (Sr.Gr.)",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/pillai.jpg",
    name: "Dr.T. Parameshwaran Pillai",
    designation: "Assistant Professor (Sr.Gr.)",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/Mr.B.%20Kumarakurubaran.jpg",
    name: "Dr.B. Kumaragurubaran",
    designation: "Assistant Professor (Sr.Gr.)",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
];

const nonteaching = [
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/Mr.%20R.%20Dhanabalan.jpg",
    name: "Mr. R. Dhanabalan",
    designation: "Administrative Staff",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/Mariasoosai.jpg",
    name: "Mr.I.Mariasoosai",
    designation: "Administrative Staff",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/V.Anusuya.jpg",
    name: "Mrs.V.Anusuya",
    designation: "Office Assistant",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
  {
    image:
      "http://www.aubit.edu.in/departments/AutomobileEngineering/img/P.Ramaraj.jpg",
    name: "Mr.P.Ramaraj",
    designation: "Office Assistant",
    resume: "#test",
    mail: "santhoshvelr@gmail.com",
  },
];


export { teaching, nonteaching };